var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.8333 10.8351C16.2945 10.8351 16.6683 10.4612 16.6683 10.0001C16.6683 9.53892 16.2945 9.16508 15.8333 9.16508V10.8351ZM4.16666 10.0001L3.57622 9.40965C3.25013 9.73573 3.25013 10.2644 3.57622 10.5905L4.16666 10.0001ZM9.40956 16.4238C9.73564 16.7499 10.2643 16.7499 10.5904 16.4238C10.9165 16.0978 10.9165 15.5691 10.5904 15.243L9.40956 16.4238ZM10.5904 4.75718C10.9165 4.43109 10.9165 3.9024 10.5904 3.57631C10.2643 3.25023 9.73564 3.25023 9.40956 3.57631L10.5904 4.75718ZM15.8333 9.16508H4.16666V10.8351H15.8333V9.16508ZM10.5904 15.243L4.75709 9.40965L3.57622 10.5905L9.40956 16.4238L10.5904 15.243ZM4.75709 10.5905L10.5904 4.75718L9.40956 3.57631L3.57622 9.40965L4.75709 10.5905Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.d0396c0d8d1df2a684bf3f9f6ca3c970.svg";
export { ForwardRef as ReactComponent };